
const ko = require('knockout');

ko.extenders.anonymous = function anonymous (target, extender, ...rest) {
	return extender(target, ...rest);
};
